module.exports = __webpack_public_path__ + "static/img/screenSaver.c08eb15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirror/screenSaver/screenSaver.png
// module id = IJsQ
// module chunks = 1